import { MenuOutlined } from "@ant-design/icons";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Button, Layout } from "antd";
import { Divider } from "primereact/divider";
import { Dropdown } from "primereact/dropdown";
import { Sidebar } from "primereact/sidebar";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";

import Earth from "../../assets/images/earth.svg";
import LanguageDropDown from "../../components/Common/LanguageDropDown";
import config from "../../config";
import { isArabic, showLangOptions } from "../../helpers/utils";
import { logout } from "../../redux/actions";

import "./style.css";

// import { useLocation } from "react-router-dom";
const { Header } = Layout;

const ApplicationSidebar = (props) => {
  const userInfo = useSelector((state) => state.userInfo);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();

  const matches = useMediaQuery(
    `(min-width:${config.breakdowns.MOBILE_MAX_WIDTH}px)`
  );
  const [language, setLanguage] = useState(i18n.language);
  const [visibleLeft, setVisibleLeft] = useState(false);

  const navigationItems = [
    {
      key: "citizn",
      label: t("header.citizinPage"),
      url: "/home",
    },
    {
      key: "gob",
      label: t("header.govServices"),
      url: "/government-services",
    },
    {
      key: "nearest",
      label: t("header.myNearest"),
      url: "/my-applications",
    },
  ];

  const navigateItem = (url) => {
    navigate(url, { replace: true });
  };

  const iaActive = (url) => {
    return location.pathname.indexOf(url) !== -1;
  };

  const getName = () => {
    const name = isArabic()
      ? userInfo.arabicShortName
      : userInfo.arabicShortName;
    return name;
  };

  return (
    <>
      <Button
        className="h-200 trigger text-white d-flex align-items-center px-2"
        onClick={() => setVisibleLeft(true)}
      >
        <MenuOutlined />
      </Button>
      <Sidebar
        style={{
          backgroundColor: "#036822",
          color: "white",
          padding: "0",
          margin: "0",
        }}
        className="sidebar-style"
        showCloseIcon={false}
        visible={visibleLeft}
        onHide={() => setVisibleLeft(false)}
      >
        <div className="d-flex align-items-center pt-2 justify-content-end mx-2">
          {showLangOptions() && <LanguageDropDown />}

          <h6 className=" text-white m-0 fm-kufi-regular">{getName()}</h6>
        </div>
        <div className="d-flex align-items-center pt-3 justify-content-end mx-2">
          <Link
            to="/profile"
            className="text-white d-block text-center mb-0 fm-kufi-regular position-relative"
            style={{
              textDecoration: "underline",
              color: "white",
              fontSize: "14px",
            }}
          >
            {t("header.changePassword")}
          </Link>
          {/* <a
            href={`${config.changePasswordLink}?token=${localStorage.getItem(
              "token"
            )}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-white d-block text-center mb-0 fm-kufi-regular position-relative"
            style={{
              textDecoration: "underline",
              color: "white",
              fontSize: "14px",
            }}
          >
            {t("header.changePassword")}
          </a> */}
        </div>
        <Divider />
        <div className="nav d-flex justify-content-end">
          <ul>
            {navigationItems.map((item) => (
              <li
                key={item.key}
                onClick={() => {
                  setVisibleLeft(false);
                  navigateItem(item.url);
                }}
                className={
                  "fm-kufi-regular mt-3 justify-content-evently  list-unstyled " +
                  (iaActive(item.url) ? "active" : "")
                }
              >
                <p className="item-label-style">{item.label}</p>
              </li>
            ))}
          </ul>
        </div>

        <div className="row justify-content-end my-5 p-5">
          <Button
            className="ant-btn ant-btn-default action-btn w-50 back-btn mt-5 fm-kufi-regular text-sm "
            onClick={() => dispatch(logout())}
            style={{
              backgroundColor: "transparent",
              border: "1px solid white",
              color: "white",
              borderRadius: "13px",
            }}
          >
            {t("header.logout")}
          </Button>
        </div>
      </Sidebar>
    </>
  );
};
export default ApplicationSidebar;
